// extracted by mini-css-extract-plugin
module.exports = {"task":"Task_task__1p05Z","content":"Task_content__2iAhw"};